import * as React from "react";

const SvgComponent = (props) => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m16 32 2.82-2.82L7.66 18H32v-4H7.66L18.84 2.84 16 0 0 16l16 16Z" fill="#000" />
  </svg>
);

export default SvgComponent;
